import React from 'react';

const containerStyle = {
  maxWidth: 860,
  margin: '0 auto',
  padding: '40px 20px 64px',
  color: '#1f2937',
  lineHeight: 1.6
};

const Eula = () => {
  return (
    <main style={containerStyle}>
      <h1 style={{ fontSize: 32, marginBottom: 8 }}>End-User License Agreement (EULA)</h1>
      <p style={{ color: '#6b7280', marginBottom: 24 }}>Last updated: May 8, 2026</p>

      <p>
        This End-User License Agreement (&quot;Agreement&quot;) is between you and Accurate Lien Searches and governs your use
        of this software and related services.
      </p>

      <h2 style={{ fontSize: 22, marginTop: 28 }}>License Grant</h2>
      <p>
        We grant you a limited, non-exclusive, non-transferable, revocable license to use the application for your
        internal business purposes.
      </p>

      <h2 style={{ fontSize: 22, marginTop: 28 }}>Restrictions</h2>
      <ul>
        <li>You may not reverse engineer, copy, resell, or redistribute the software without written permission.</li>
        <li>You may not use the service for unlawful activity.</li>
      </ul>

      <h2 style={{ fontSize: 22, marginTop: 28 }}>Third-Party Services</h2>
      <p>
        The application may connect to third-party providers (including Intuit QuickBooks). Use of those services is
        subject to their own terms and policies.
      </p>

      <h2 style={{ fontSize: 22, marginTop: 28 }}>Disclaimer</h2>
      <p>
        The software is provided &quot;as is&quot; without warranties of any kind, to the maximum extent permitted by law.
      </p>

      <h2 style={{ fontSize: 22, marginTop: 28 }}>Limitation of Liability</h2>
      <p>
        To the maximum extent permitted by law, Accurate Lien Searches is not liable for indirect, incidental, or
        consequential damages arising from use of the software.
      </p>

      <h2 style={{ fontSize: 22, marginTop: 28 }}>Termination</h2>
      <p>We may suspend or terminate access if this Agreement is violated.</p>

      <h2 style={{ fontSize: 22, marginTop: 28 }}>Contact</h2>
      <p>Questions about this Agreement: info@accurateliensearch.net</p>
    </main>
  );
};

export default Eula;
